package team.platforma.dictionary_domain.use_case.ai_model

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.transform
import team.platforma.dictionary_data.repository.AiChapterRepository
import team.platforma.dictionary_data.repository.ai_model.AiModelRepository
import team.platforma.dictionary_domain.model.AiChapterDomain
import team.platforma.dictionary_domain.model.AiModelDomain

class AiModelTableUseCase(
    private val repository: AiModelRepository
) {
    fun observeAll(): Flow<List<AiModelDomain>> = repository.observeAll().transform { value ->
        val list = value.map { AiModelDomain(it.id, it.name, it.chapter, it.description, it.cover) }
        return@transform emit(list)
    }

    fun observeByChapter(chapter: Long): Flow<List<AiModelDomain>> = repository.observeByChapter(chapter).transform { value ->
        val list = value.map { AiModelDomain(it.id, it.name, it.chapter, it.description, it.cover) }
        return@transform emit(list)
    }
}